var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isShowQr,
          expression: "isShowQr",
        },
      ],
      staticClass: "esignCode",
    },
    [
      _c("div", { staticClass: "esignCodeData" }, [
        _c("em", {
          staticClass: "el-icon-close detIcon",
          on: {
            click: function ($event) {
              return _vm.isShowOpen()
            },
          },
        }),
        _c("div", { staticClass: "qrcodeBorder" }, [
          _c("div", { ref: "qrCodeUrl", attrs: { id: "qrcode" } }),
        ]),
        _c("p", { staticClass: "describe" }, [_vm._v("扫描二维码手写签名")]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }